<template>
	<!-- 编辑界面 -->
	<el-drawer :visible.sync="editFormVisible" :title="title" :size="600" :wrapper-closable="false" :modal="false" :destroy-on-close="true" class="margin_top_40" @click="closeDialog">
		<el-form ref="editForm" label-width="8.75rem" :model="editForm" :rules="rules">
			<el-form-item label="商品品牌" prop="type">
				<el-input clearable v-model="editForm.type" class="input_200px" size="small" auto-complete="off" placeholder="请输入商品品牌"></el-input>
			</el-form-item>
			<el-form-item label="商品名称" prop="name">
				<el-input clearable v-model="editForm.name" class="input_200px" size="small" auto-complete="off" placeholder="请输入商品名称"></el-input>
			</el-form-item>
			<el-form-item label="单位" prop="unit">
				<el-input clearable v-model="editForm.unit" class="input_200px" size="small" auto-complete="off" placeholder="请输入单位"></el-input>
			</el-form-item>
			<el-form-item label="成本价(元)" prop="costMoney">
				<el-input-number v-model="editForm.costMoney" class="input_200px" size="small" :min="0" :step="0.01" auto-complete="off" placeholder="请输入成本价(元)"></el-input-number>
			</el-form-item>
		</el-form>
		<div class="drawer-footer">
			<el-button size="small" icon="el-icon-check" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
		</div>
	</el-drawer>
</template>

<script>
import { SaveGoodsType, GetGoodsTypeDetail } from "@/api/baseDataApi.js";
export default {
	data() {
		return {
			title: "",
			loading: false, //是显示加载
			editFormVisible: false, //控制编辑页面显示与隐藏
			editForm: {
				keyId: "",
				type: "",
				name: "",
				unit: "",
				parentKeyId: "",
				isOnline: true,
				costMoney: 0
			},
			// rules 表单验证
			rules: {
				type: [
					{
						required: true,
						message: "请输入商品品牌",
						trigger: "blur"
					}
				],
				name: [
					{
						required: true,
						message: "请输入商品名称",
						trigger: "blur"
					}
				],
				unit: [
					{
						required: true,
						message: "请输入单位",
						trigger: "blur"
					}
				],
				costMoney: [
					{
						required: true,
						message: "请输入成本价(元)",
						trigger: "blur"
					},
					{
						type: "number",
						message: "请输入数字",
						trigger: "blur"
					}
				]
			}
		};
	},
	computed: {},
	watch: {},

	methods: {
		//显示编辑界面
		//type：1新增，2编辑，3新增子项
		editShow(row, type) {
			this.$data.editForm = this.$options.data.call(this).editForm;
			if (type == 2) {
				this.title = "编辑";
				let parmer = {
					keyId: row.keyId
				};
				GetGoodsTypeDetail(parmer)
					.then((res) => {
						if (res.code == 1) {
							this.editForm.keyId = res.data.keyId;
							this.editForm.type = res.data.type;
							this.editForm.name = res.data.name;
							this.editForm.unit = res.data.unit;
							this.editForm.parentKeyId = res.data.parentKeyId;
							this.editForm.isOnline = res.data.isOnline;
							this.editForm.costMoney = res.data.costMoney;
							this.editFormVisible = true;
						} else {
							this.$message.error(res.msg);
						}
					})
					.catch((err) => {
						this.loading = false;
						this.$message.error("商品类型获取失败!");
					});
			} else if (type == 1) {
				this.title = "新增";
				this.editFormVisible = true;
				this.editForm.parentKeyId = "";
			} else if (type == 3) {
				this.title = "新增子项";
				this.editForm.parentKeyId = row.keyId;
				this.editFormVisible = true;
			}
		},
		// 编辑、增加页面保存方法
		submitForm(editData) {
			this.$refs[editData].validate((valid) => {
				if (valid) {
					SaveGoodsType(this.editForm)
						.then((res) => {
							this.editFormVisible = false;
							this.loading = false;
							if (res.code == 1) {
								this.$parent.getListData();
								this.$message({
									type: "success",
									message: "商品类型保存成功！"
								});
							} else {
								this.$message({
									type: "info",
									message: res.msg
								});
							}
						})
						.catch((err) => {
							this.editFormVisible = false;
							this.loading = false;
							this.$message.error("商品类型保存失败，请稍后再试！");
						});
				} else {
					return false;
				}
			});
		},
		// 关闭编辑、增加弹出框
		closeDialog() {
			this.editFormVisible = false;
			this.$data.editForm = this.$options.data.call(this).editForm;
		}
	},
	created() {},
	mounted() {},
	components: {}
};
</script>
<style scoped>
.wip {
	width: 200px !important;
}
</style>
